import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {deriveStepUiSchema} from 'pipelines/generalized-step-config-editor/step-config-settings/deriveStepUiSchema';
import {getStepTypeConfigShape} from 'pipelines/StepShapeUtils';

import {StepTypeConfigUISchemaV2} from '../step-config-settings/StepConfigUISchemas';

const UPDATE_ENTITIES_BASE_UI_SCHEMA = deriveStepUiSchema(
  getStepTypeConfigShape(PipelineStepType.UPDATE_ENTITIES, 0).fields
);

export const UPDATE_ENTITIES_V0_UI_SCHEMA = {
  ...UPDATE_ENTITIES_BASE_UI_SCHEMA,
  columnMapping: {
    ...UPDATE_ENTITIES_BASE_UI_SCHEMA.columnMapping,
    fieldSettings: {
      subfieldDisplayNames: {
        id: 'API ID',
        registryId: 'Registry ID',
        entityRegistryId: 'Entity registry ID',
      },
      subfieldInfoText: {
        id: 'API ID of the entity to update. Map this or Registry ID, not both.',
        registryId: 'Registry ID of the entity to update. Map this or API ID, not both.',
        entityRegistryId: 'New registry ID to assign. Leave unmapped to keep the current registry ID.',
      },
      exclusiveSubfieldGroups: [['id', 'registryId']],
    },
  },
} as StepTypeConfigUISchemaV2<PipelineStepType.UPDATE_ENTITIES, 0>;
